import { ComponentProps, ReactNode, Suspense } from "react";
import { useTranslation } from "react-i18next";

import { TableBody, TableRow, Typography } from "@mui/material";
import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";
import { LoadingBox } from "@shared/Loading";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

import type SortablePolicyCommandsBodyComponent from "./SortablePolicyCommandsBody";

const LazySortablePolicyCommandsBody = lazyChunk(() => import("./SortablePolicyCommandsBody"));

const MessageBody = ({ children }: { children: ReactNode }) => (
    <TableBody>
        <TableRow>
            <MinimalTableCell colSpan={4}>{children}</MinimalTableCell>
        </TableRow>
    </TableBody>
);

const LoadFailedBody = () => {
    const { t } = useTranslation("common");

    return (
        <MessageBody>
            <Typography color="error">{t("error.failedToLoadFeature")}</Typography>
        </MessageBody>
    );
};

export const SortablePolicyCommandsBody = (props: ComponentProps<typeof SortablePolicyCommandsBodyComponent>) => (
    <ChunkLoadErrorBoundary fallback={<LoadFailedBody />}>
        <Suspense
            fallback={
                <MessageBody>
                    <LoadingBox />
                </MessageBody>
            }
        >
            <LazySortablePolicyCommandsBody {...props} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
